// src/utils/bundleHelpers.ts

/**
 * Compute a simple hash of a string (32-bit int).
 */
export function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash |= 0; // Convert to 32bit int
  }
  return Math.abs(hash);
}

/**
 * Derive a pseudo-random “rating” from bundle ID.
 * (5.0 if even hash, else 4.5)
 */
export function getBundleRating(id: string | number): number {
  return hashString(id.toString()) % 2 === 0 ? 5 : 4.5;
}

/**
 * Derive a pseudo-random “review count” from bundle ID.
 */
export function getBundleReviewCount(id: string | number): number {
  return (hashString(id.toString()) % 241) + 10;
}
